import { defineComponent as _defineComponent } from 'vue'
import { indefinite } from '@/utils/language-service';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlacementRowContent',
  props: {
    itemName: null,
    entityName: null
  },
  setup(__props: any) {

const props = __props as { itemName: string; entityName: string }


const indefiniteEntityName = computed(() => indefinite(props.entityName));

return { __sfc: true,props, indefiniteEntityName }
}

})